import { Grid, Theme } from "@mui/material";
import { IReportTreeNode, ReportType } from "@vmosolutions/oc-interfaces";
import { useState } from "react";
import { useSelector } from "react-redux";
import { ReportDetails } from "src/components/Reporting/ReportDetails";
import { ReportTreeView } from "src/components/Reporting/ReportTreeView";
import { IRootState } from "src/redux/reducers/CombinedReducers";

interface IReportTreeViewWindowProps {
  id: string;
  path: string[];
}

export const defaultReport: IReportTreeNode = {
  _id: undefined,
  nodeType: ReportType.folder,
  name: undefined,
  parentId: undefined,
  readonly: false,
  children: [],
};

const reportViewContentStyles = (theme: Theme): any => ({
  root: {
    display: "flex",
    flexGrow: 5,
    padding: "1rem",
    flexBasis: "0px",
    borderLeft: `1px solid ${theme.custom.forms.inputBorder}`,
    "& .report_details": {
      marginTop: "20px",
      "& .value": {
        marginLeft: 10,
        color: theme.palette.primary.contrastText,
      },
      "& .resetfields_btn": {
        width: "80px",
        padding: "2px 8px",
        margin: "5px",
        borderRadius: "3px",
      },
      "& .openreport_btn, & .editreport_btn": {
        width: "150px",
        padding: "2px 8px",
        margin: "5px",
        borderRadius: "3px",
      },
    },
  },
});

export const ReportTreeViewWindow = (props: IReportTreeViewWindowProps): JSX.Element => {
  const { id, path } = props;
  const rootReportNode = useSelector((state: IRootState) => state.reports.rootReportNode);
  const [activeNode, setActiveNode] = useState<IReportTreeNode | null>(defaultReport);

  return (
    <Grid container direction="row" wrap="nowrap" style={{ height: "100%", overflow: "hidden" }}>
      <ReportTreeView
        rootReportNode={rootReportNode}
        defaultNode={defaultReport}
        activeNode={activeNode}
        setActiveNode={setActiveNode}
      />
      <Grid item sx={(theme) => ({ ...reportViewContentStyles(theme).root, overflow: "auto" })}>
        <ReportDetails id={id} path={path} activeNode={activeNode} setActiveNode={setActiveNode} />
      </Grid>
    </Grid>
  );
};
